import { useNavigate, useParams } from 'react-router-dom'
import { Helper } from '@utils'
import { useEffect } from 'react'
import { Appointment } from '@apis'
import Column from '@components/column'
import Overview from '@commons/cards/appointmentDetails/overview'
import Consultation from '@commons/cards/appointmentDetails/consultation'
import LabTests from '@commons/cards/appointmentDetails/labTests'
import Medicines from '@commons/cards/appointmentDetails/medicines'
import Tabs from '@commons/tabs'
import { StyleGrid } from './style'
import { useSelector } from 'react-redux'
import Skeleton from '@components/skeleton'
import AppointmentDoctorCard from '@commons/cards/appointmentDetails/doctor'
import AppointmentPatientCard from '@commons/cards/appointmentDetails/patient'
import AppointmentInfoCard from '@commons/cards/appointmentDetails/info'
import Button from '@components/button'
import Svg from '@components/svg'
import Row from '@components/row'
import { Actions, store } from '@store'

const InstituteAppointmentDetailsPage = () => {
  const { slug } = useParams()
  const navigate = useNavigate()
  const { data: appointment, loading } = useSelector(
    (state: any) => state.consultAppointment,
  )
  const id = Helper.getIdFromSlug(slug)
  const tabs = [
    {
      title: 'Overview',
      key: 'overview',
      Component: Overview,
    },
    {
      title: 'Consultation',
      key: 'consultation',
      Component: Consultation,
      props: {
        canSave: false,
      },
    },
    {
      title: 'Lab Test',
      key: 'lab-tests',
      Component: LabTests,
      props: {
        canSave: false,
      },
    },
    {
      title: 'Medicines',
      key: 'medicines',
      Component: Medicines,
      props: {
        canSave: false,
      },
    },
  ]
  const fetchData = async () => {
    await Appointment.find({
      id: id,
      state: 'consultAppointment',
    }).catch(() => {})
  }
  useEffect(() => {
    if (!!id) {
      fetchData()
    }
    return () => {
      store.dispatch(Actions.reset('pastReports'))
    }
  }, [id])
  return (
    <Column>
      <Column styleColumn="margin-bottom:20px;">
        <StyleGrid>
          {!!loading ? (
            <>
              <Skeleton width={'100%'} height={120} radius={12} />
              <Skeleton width={'100%'} height={120} radius={12} />
              <Skeleton width={'100%'} height={120} radius={12} />
            </>
          ) : (
            <>
              <AppointmentPatientCard
                name={appointment?.patient?.name}
                avatar={appointment?.patient?.avatar}
                gender={appointment?.patient?.infos?.gender}
                age={appointment?.patient?.infos?.age}
                bloodGroup={appointment?.patient?.infos?.bloodGroup}
              />
              <AppointmentInfoCard
                id={appointment?.id}
                status={appointment?.status}
                paymentStatus="Unpaid"
                date={appointment?.date}
                appointmentType={appointment?.infos?.appointmentType}
              />

              <AppointmentDoctorCard
                name={appointment?.appointmentWith?.name}
                avatar={appointment?.appointmentWith?.avatar}
                department={appointment?.appointmentWith?.departments[0]?.name}
                qualification={
                  appointment?.appointmentWith?.infos?.qualification
                }
                experience={appointment?.appointmentWith?.infos?.yos}
              />
            </>
          )}
        </StyleGrid>
      </Column>
      <Tabs
        items={tabs}
        rightComponent={
          <Row colGap={15}>
            {!!appointment?.infos?.report && (
              <Button
                title="View Report"
                height={40}
                onClick={() => {
                  window.open(appointment?.infos?.report, '_blank')
                }}
              />
            )}
            <Button
              title="Message Now"
              outline
              leftComponent={<Svg svg="message" color="primary" />}
              height={40}
              onClick={() => {
                navigate(`/doctor/chats`, {
                  state: {
                    receiver: {
                      id: appointment?.patient?.id,
                      name: appointment?.patient?.name,
                      avatar: appointment?.patient?.avatar,
                    },
                  },
                })
              }}
            />
          </Row>
        }
      />
    </Column>
  )
}

export default InstituteAppointmentDetailsPage
